<template>
  <div id="OrderList">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <b-row class="mb-3">
            <b-col sm="6" class="mb-2">
              <h2>รายการข้อมูลพรีออร์เดอร์</h2>
            </b-col>
            <b-col sm="6">

              <b-card body-class="p-0">
                <b-card-body>
                  <b-form @submit="onSubmit">
                    <b-card-text>
                      <template v-if="userData.userType === 'A'">
                        <label for="form_userCode" class="mb-1">รหัสสมาชิก:</label>
                        <b-input-group class="mb-2">
                          <b-form-input id="form_userCode" v-model="form.userCode" type="text" autocomplete="off"></b-form-input>
                        </b-input-group>
                      </template>

                      <label for="form_preorderCode" class="mb-1">หมายเลขคำสั่งซื้อ:</label>
                      <b-input-group class="mb-2">
                        <b-form-input id="form_preorderCode" v-model="form.preorderCode" type="text" autocomplete="off"></b-form-input>
                        <b-input-group-append>
                          <!-- @click="getDataTrackPreOrder" -->
                          <b-button variant="success" type="submit">ค้นหา</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-card-text>
                  </b-form>

                  <b-button v-if="userData.userType === 'A'" variant="outline-success" block to="OrderCreate"><f-icon icon="cart-plus"></f-icon> สร้างใบพรีออร์เดอร์</b-button>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <!-- <hr class="my-2"> -->
          <b-skeleton-table
            :rows="4"
            :columns="3"
            :table-props="{ bordered: true, striped: true }"
            v-if="!dataReady"
          ></b-skeleton-table>
          <template v-if="dataReady">
            <h4>รายการรหัสพัสดุรอรหัสจัดส่งพัสดุในจีน</h4>
            <b-table fixed
              :items="waitItems" :fields="userData.userType === 'A' ? fields : userFields"
              :current-page="currentPage"
              :per-page="perPage"
              show-empty table-variant="warning"
              empty-text="ไม่พบข้อมูล"
              >

              <template #cell(preorderCode)="data">
                {{data.item.list[0].preorderCode}}
                <br />
                <i style="font-size: x-small;">วันที่สร้าง: {{ data.item.list[0].CREATE_DATE.split(' ')[0] }}</i>
              </template>

              <template #cell(userCode)="data">
                {{data.item.list[0].userCode}}
              </template>

              <template #cell(shippingChinaCode)="data">
                {{data.item.list[0].shippingChinaCode}}
              </template>

              <template #cell(shopChina)="data">
                {{data.item.list[0].shopChina}}
              </template>
              
              <template #cell(itemPreOrder)="data">
                <b-button variant="link" class="py-0" @click="data.toggleDetails"><f-icon icon="th-list"></f-icon> {{data.item.list.length}}</b-button>
              </template>

              <template #cell(action)="data">
                <b-button variant="info" size="sm" class="mb-1" v-b-tooltip.hover title="แก้ไขข้อมูล" @click="editDataTrack(data.item)">
                  <f-icon icon="edit"></f-icon>
                </b-button>
                <b-button variant="danger" size="sm" class="mb-1" v-b-tooltip.hover title="ลบข้อมูล" @click="delConfirm(data.item)">
                  <f-icon icon="trash-alt"></f-icon>
                </b-button>
              </template>

              <template #row-details="row">
                <b-card bg-variant="secondary" body-class="pb-0 px-3 pt-3">
                  <b-alert v-for="itemUrl in row.item.list" :key="itemUrl.trackPreorderId" show variant="warning">
                    <b-avatar rounded="lg" size="72px" v-if="!!itemUrl.picturePreorder" :src="itemUrl.picturePreorder"></b-avatar>
                    <a :href="itemUrl.url" class="alert-link ml-2">{{itemUrl.url}}</a>
                    <p class="m-0" v-if="itemUrl.remark">
                      <b-badge class="right-badge">หมายเหตุ: {{itemUrl.remark}}</b-badge>
                    </p>
                  </b-alert>
                </b-card>
              </template>

            </b-table>
            <hr />
            <h4>รายการรหัสพัสดุ</h4>
            <b-table fixed
              :items="items" :fields="userData.userType === 'A' ? fields : userFields"
              :current-page="currentPage"
              :per-page="perPage"
              show-empty
              empty-text="ไม่พบข้อมูล"
              >

              <template #cell(preorderCode)="data">
                {{data.item.list[0].preorderCode}}
                <br />
                <i style="font-size: x-small;">วันที่สร้าง: {{ data.item.list[0].CREATE_DATE.split(' ')[0] }}</i>
              </template>

              <template #cell(userCode)="data">
                {{data.item.list[0].userCode}}
              </template>

              <template #cell(shippingChinaCode)="data">
                {{data.item.list[0].shippingChinaCode}}
              </template>

              <template #cell(shopChina)="data">
                {{data.item.list[0].shopChina}}
              </template>
              
              <template #cell(itemPreOrder)="data">
                <b-button variant="link" class="py-0" @click="data.toggleDetails"><f-icon icon="th-list"></f-icon> {{data.item.list.length}}</b-button>
              </template>

              <template #cell(action)="data">
                <b-button variant="info" size="sm" class="mb-1" v-b-tooltip.hover title="แก้ไขข้อมูล" @click="editDataTrack(data.item)">
                  <f-icon icon="edit"></f-icon>
                </b-button>
                <b-button variant="danger" size="sm" class="mb-1" v-b-tooltip.hover title="ลบข้อมูล" @click="delConfirm(data.item)">
                  <f-icon icon="trash-alt"></f-icon>
                </b-button>
              </template>

              <template #row-details="row">
                <b-card body-class="pb-0 px-3 pt-3">
                  <b-alert v-for="itemUrl in row.item.list" :key="itemUrl.trackPreorderId" show variant="info">
                    <b-avatar rounded="lg" size="72px" v-if="!!itemUrl.picturePreorder" :src="itemUrl.picturePreorder"></b-avatar>
                    <a :href="itemUrl.url" class="alert-link ml-2">{{itemUrl.url}}</a>
                    <p class="m-0" v-if="itemUrl.remark">
                      <b-badge class="right-badge">หมายเหตุ: {{itemUrl.remark}}</b-badge>
                    </p>
                  </b-alert>
                </b-card>
              </template>

            </b-table>
            <b-pagination
              v-model="currentPage"
              pills first-number last-number
              v-if="totalRows > perPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
            ></b-pagination>
          </template>

        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "OrderList",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataTrackPreOrder()
  },
  data() {
    return {
      fields: [
        { key: 'trackPreorderCode', label: 'รหัสใบพรีออร์เดอร์', thClass: 'py-2 w-140 small', tdClass: 'small w-140' },
        { key: 'preorderCode', label: 'หมายเลขคำสั่งซื้อ', thClass: 'py-2 w-min-220', tdClass: 'w-min-220' },
        { key: 'userCode', label: 'รหัสสมาชิก', tdClass: 'w-min-100', thClass: 'py-2 w-min-100' },
        { key: 'shippingChinaCode', label: 'หมายเลขจัดส่งในจีน', thClass: 'py-2' },
        { key: 'shopChina', label: 'แพลทฟอร์ม', thClass: 'py-2' },
        { key: 'itemPreOrder', label: 'รายการสินค้า', tdClass: 'text-center', thClass: 'py-2 text-center' },
        { key: 'action', label: 'จัดการ', tdClass: 'p-2', thClass: 'py-2', class: 'w-90' }
      ],
      userFields: [
        // { key: 'trackPreorderCode', label: 'รหัสใบพรีออร์เดอร์', thClass: 'py-2 w-140' },
        { key: 'preorderCode', label: 'หมายเลขคำสั่งซื้อ', thClass: 'py-2 w-min-220', tdClass: 'w-min-220' },
        // { key: 'userCode', label: 'รหัสสมาชิก', tdClass: 'w-min-100', thClass: 'py-2 w-min-100' },
        { key: 'shippingChinaCode', label: 'หมายเลขจัดส่งในจีน', thClass: 'py-2' },
        { key: 'shopChina', label: 'แพลทฟอร์ม', thClass: 'py-2' },
        { key: 'itemPreOrder', label: 'รายการสินค้า', tdClass: 'text-center', thClass: 'py-2 text-center' },
      ],
      waitItems: [ ],
      items: [ ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      userData: {
        userName: '',
        userCode: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        preorderCode: '',
        userCode: ''
      },
      dataReady: true,
    };
  },
  methods: {
    formatDate (dtDate) {
      if (dtDate) {
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0].substring(2, 4)
        return strDateShort
      } else {
        return ''
      }
    },
    getDataUser () {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
      } else {
        this.$router.push('/Login')
      }
    },
    onSubmit (event) {
      event.preventDefault()
      this.getDataTrackPreOrder()
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getDataTrackPreOrder () {
      this.dataReady = false;
      this.items = [];
      this.waitItems = [];

      this.totalRows = 0
      let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Track_preorder/Track_preorder_list?userName=' +
          this.userData.userName +
          '&userCode=' +
          uc +
          '&preorderCode=' +
          this.form.preorderCode,
          {
            headers: this.getHeaderAPI('Track_preorder_list', this.userData.userName)
          }
        )
        .then((response) => {
          console.log('getDataTrackPreOrder', response.data)

          const rs = response.data
          if (rs.status === true){
            // const obj = this.groupBy(rs.data, 'trackPreorderCode');
            const arrayOfObjects = Object.keys(rs.data).map(key => {
              return {
                'trackPreorderCode': key,
                'list': rs.data[key],
              }
            });
            // console.log(arrayOfObjects)
            arrayOfObjects.forEach((dataPre => {
              if(dataPre.list[0].shippingChinaCode) {
                this.items.push(dataPre)
              } else {
                this.waitItems.push(dataPre)
              }
            }))
            // this.items = arrayOfObjects
            this.totalRows = arrayOfObjects.length
          } else {
            this.items = []
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTrackPreOrder error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    editDataTrack (dt) {
      console.log('editDataTrack', dt)
      this.$router.push('/pod/OrderUpdate?trackPreorderCode='+dt.trackPreorderCode)
    },
    delConfirm (dt) {
      this.$swal({
        title: 'ยืนยันการลบ ' + dt.trackPreorderCode,
        text: 'คุณต้องการลบใบพรีออร์เดอร์ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delDataTrack(dt.trackPreorderCode)
        }
      })
    },
    delDataTrack (dt) {
      console.log('delDataTrack Track Pre-order Code: ', dt)
      var LASTuserName = this.userData.userName
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Track_preorder/Track_preorder_delete",
          {
            trackPreorderCode: dt,
            // userName: this.userData.userName,
            LAST_USER: LASTuserName,
          },
          {
            headers: this.getHeaderAPI('Track_preorder_delete', this.userData.userName)
          }
        )
        .then(async (response) => {
          console.log('delDataTrack resp: ', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","ลบข้อมูลพรีออร์เดอร์เรียบร้อย","success")
            this.dataReady = true
            this.getDataTrackPreOrder()
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถลบข้อมูลพรีออร์เดอร์ได้","error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถลบข้อมูลพรีออร์เดอร์ได้","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.right-badge{
  float: right;
  margin-top: 3px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/PreOrder/OrderList.vue